import { AxiosResponse } from 'axios'
import { API } from '../config'
import { VaccineDto } from 'src/dto/vaccine.dto'

const BASE_URL = '/domain/Vacina'

export class VaccineService {
  public async getVaccineList(): Promise<AxiosResponse<VaccineDto[]>> {
    return await API.get<VaccineDto[]>(`${BASE_URL}`)
  }
}
